import type { Rosters } from '../types/roster';
import { getTimesheetsMockByEmployeeId } from '@/lib/request/mock/timesheets.mock';
import { DateTime } from 'luxon';

const rosters: Rosters = [
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 1,
    EndTime: DateTime.now().plus({ hours: 4 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 1,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 9000,
        intStart: 7200,
        intUnixEnd: 1663648200,
        intUnixStart: 1663646400,
        mixedActivity: {
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          intState: 0,
          strBreakType: 'M',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    StartTime: DateTime.now().toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 1,
    EndTime: DateTime.now().plus({ hours: 4 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 2,
    MatchedByTimesheet: 5,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 9000,
        intStart: 7200,
        intUnixEnd: 1663648200,
        intUnixStart: 1663646400,
        mixedActivity: {
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          intState: 0,
          strBreakType: 'M',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    StartTime: DateTime.now().plus({ hours: 1 }).toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 1,
    EndTime: DateTime.now().plus({ hours: 20 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 3,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 9000,
        intStart: 7200,
        intUnixEnd: 1663648200,
        intUnixStart: 1663646400,
        mixedActivity: {
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          intState: 0,
          strBreakType: 'M',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    StartTime: DateTime.now().toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 3,
    EndTime: DateTime.now().plus({ hours: 4 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 1,
    MatchedByTimesheet: 6,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 9000,
        intStart: 7200,
        intUnixEnd: 1663648200,
        intUnixStart: 1663646400,
        mixedActivity: {
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          intState: 0,
          strBreakType: 'M',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    StartTime: DateTime.now().minus({ hours: 1 }).toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 4,
    EndTime: DateTime.now().plus({ hours: 4 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 4,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 1800,
        intStart: 0,
        intUnixEnd: 1671229800,
        intUnixStart: 1671228000,
        mixedActivity: {
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          intState: 0,
          strBreakType: 'M',
        },
        strState: 'Scheduled Duration',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    StartTime: DateTime.now().minus({ minutes: 10 }).toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 5,
    EndTime: DateTime.now().plus({ hours: 8 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 1,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [],
    StartTime: DateTime.now().plus({ minutes: 10 }).toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 9,
    EndTime: DateTime.now().plus({ hours: 8 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 1,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [],
    StartTime: DateTime.now().plus({ minutes: 10 }).toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 10,
    EndTime: DateTime.now().plus({ hours: 4 }).toSeconds(),
    EndTimeLocalized: DateTime.now().plus({ hours: 4 }).toISO(),
    ExternalId: null,
    Id: 1,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [],
    StartTime: DateTime.now().minus({ hours: 1 }).toSeconds(),
    StartTimeLocalized: DateTime.now().minus({ hours: 1 }).toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 12,
    EndTime: DateTime.now().plus({ hours: 8 }).toSeconds(),
    EndTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() + 20 * 60000
    ).toISO(),
    ExternalId: null,
    Id: 1,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [],
    StartTime: DateTime.now().plus({ hours: 1 }).toSeconds(),
    StartTimeLocalized: DateTime.now().toISO(),
    TotalTime: 5,
  },
  {
    ApprovalRequired: false,
    BidsCount: null,
    Comment: '',
    ConnectCreator: null,
    Date: '2022-09-20T00:00:00+09:30',
    Employee: 19,
    EndTime: DateTime.now().plus({ hours: 4 }).toSeconds(),
    EndTimeLocalized: DateTime.now().plus({ hours: 4 }).toISO(),
    ExternalId: null,
    Id: 1,
    MatchedByTimesheet: 0,
    Mealbreak: '2022-09-20T00:30:00+09:30',
    Modified: '2022-09-20T12:52:30+09:30',
    OnCost: 100,
    OperationalUnit: 1,
    ShiftTemplate: 1,
    Slots: [],
    StartTime: DateTime.now().minus({ hours: 1 }).toSeconds(),
    StartTimeLocalized: DateTime.now().minus({ hours: 1 }).toISO(),
    TotalTime: 5,
  },
];

export function getRostersMock() {
  return rosters;
}

export function getRostersMockByEmployeeId(id: number) {
  return rosters.filter((roster) => roster.Employee === id);
}

export function filterRostersNotStarted(id: number) {
  const timesheets = getTimesheetsMockByEmployeeId(id);
  const rosters = getRostersMockByEmployeeId(id);

  const timesheetIds = timesheets.map((timesheet) => {
    return timesheet.Id;
  });

  const notStarted: Rosters = [];
  rosters.map((roster) => {
    if (!timesheetIds.includes(roster.Id)) {
      notStarted.push(roster);
    }
  });
  return notStarted;
}
